import BaseDTO from '../base/BaseDTO';
import Country from '../country/Country';

export default class Dealership extends BaseDTO {

    public name: string | undefined;
    public gssn: string | undefined;
    public country: Country | undefined;

    constructor(data: { [key: string]: any }) {
        super(data);
        this.name = data['name'] || undefined;
        this.gssn = data['gssn'] || undefined;
        this.country = data['country'] ? new Country(data['country']) : undefined;
    }
}
